export type MessageTree = {
  nav: {
    menu: string
    solutions: string
    guides: string
    shop: string
    used: string
    ecosystem: string
    account: string
    cart: string
    home: string
    contact: string
    language: string
    searchOpen: string
    searchClose: string
  }
  chat: {
    askProducts: string
    team: string
    line: string
    modeAssistant: string
    modeTeam: string
    modeLine: string
    subtitleAssistant: string
    subtitleTeam: string
    subtitleLine: string
    greeting: string
    greetingHint: string
    teamHint: string
    placeholderAssistant: string
    placeholderTeam: string
    lineTitle: string
    lineBody: string
    lineCta: string
    lineHint: string
    close: string
    clear: string
    unavailable: string
    connectFailed: string
    errorGeneric: string
  }
  home: {
    metaTitle: string
    metaDescription: string
    solutionsCta: string
    shopCta: string
    whatsNewTitle: string
    whatsNewBody: string
    whatsNewCta: string
  }
  footer: {
    blurb: string
    solutions: string
    shop: string
  }
}

export const thTH: MessageTree = {
  nav: {
    menu: "เมนู",
    solutions: "โซลูชัน",
    guides: "ความรู้",
    shop: "ร้านค้า",
    used: "มือสอง",
    ecosystem: "ซอฟต์แวร์ในเครือ",
    account: "บัญชี",
    cart: "ตะกร้า",
    home: "หน้าแรก",
    contact: "ติดต่อ",
    language: "ภาษา",
    searchOpen: "เปิดค้นหา",
    searchClose: "ปิดค้นหา",
  },
  chat: {
    askProducts: "ถามสินค้า",
    team: "คุยกับทีม",
    line: "LINE",
    modeAssistant: "ถามสินค้า",
    modeTeam: "คุยกับทีม",
    modeLine: "LINE",
    subtitleAssistant: "ช่วยหาสินค้าและตอบคำถามแคตตาล็อก",
    subtitleTeam: "ส่งข้อความถึงทีม VX Work",
    subtitleLine: "คุยกับทีม VX Work ผ่าน LINE Official Account",
    greeting: "สวัสดีครับ วันนี้ให้ช่วยหาอะไรในแคตตาล็อกดี",
    greetingHint: "ถามรุ่น สเปก หรืองบได้เลย — จะค้นจากสินค้าจริงในร้านให้",
    teamHint: "ถามสินค้า บริการ หรือใบเสนอราคาได้เลย",
    placeholderAssistant: "พิมพ์คำถาม หรือเลือกหัวข้อด้านบน…",
    placeholderTeam: "พิมพ์ถึงทีม เช่น มี CRS328 พร้อมส่งไหม…",
    lineTitle: "LINE Official Account",
    lineBody: "คุยกับทีม VX Work บน LINE",
    lineCta: "เริ่มแชท LINE ตอนนี้",
    lineHint: "กรณีต้องการคุยผ่านแอป LINE โดยตรง กดปุ่มด้านล่าง",
    close: "ปิดแชท",
    clear: "ล้างแชท",
    unavailable: "ผู้ช่วยยังไม่พร้อมใช้งาน กรุณาลองใหม่ภายหลัง",
    connectFailed: "เชื่อมต่อผู้ช่วยไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
    errorGeneric: "เกิดข้อผิดพลาดขณะติดต่อผู้ช่วย กรุณาลองใหม่",
  },
  home: {
    metaTitle: "VX Work — โซลูชันเครือข่ายและซอฟต์แวร์",
    metaDescription:
      "ฮับความรู้และโซลูชันเครือข่ายสำหรับโรงแรมกับออฟฟิศ พร้อมร้านค้าอุปกรณ์และซอฟต์แวร์ในเครือ เช่น KEOS",
    solutionsCta: "ดูโซลูชัน →",
    shopCta: "เปิดร้านค้า",
    whatsNewTitle: "ของใหม่ในร้าน",
    whatsNewBody: "รุ่นที่น่าสนใจจากร้านค้า — ดูสเปกแล้วปรึกษาทีมได้",
    whatsNewCta: "เปิดร้านค้า →",
  },
  footer: {
    blurb:
      "ฮับโซลูชันเครือข่ายและซอฟต์แวร์สำหรับโรงแรม ออฟฟิศ และ SME —",
    solutions: "โซลูชัน",
    shop: "ร้านค้า",
  },
}
